import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONSTANTS, palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  activityOverview: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  cellContent: {
    width: '100%',
    padding: '10px 6px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textAlign: 'left'
  },
  searchBar: {
    padding: '20px 24px',
    boxShadow: palette.shadows.light,
    background: palette.gradients.white,
    display: 'flex',
    marginTop: '32px',
    marginBottom: '10px',
    borderRadius: '2px',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexWrap: 'wrap'
    }
  },
  searchField: {
    flexGrow: '1',
    marginRight: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      marginRight: '0',
      marginBottom: '20px'
    }
  },
  filterSelector: {
    width: '240px',
    '& + &': {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: 'initial',
      flex: '1 1 0'
    }
  },
  chargesRangeDatePicker: {
    marginLeft: '10px',
    width: '130px'
  },
  pageContainer: {
    paddingBottom: "".concat(CONSTANTS.PAGE_BOTTOM_PADDING, "px")
  },
  datePicker: {
    marginLeft: '10px'
  },
  rightAlign: {
    textAlign: 'right'
  }
}));
export default useStyles;